import { startRegistration, startAuthentication } from '@simplewebauthn/browser';

// Wraps the two browser ceremonies so the DOM exceptions they throw arrive at
// the call sites as German sentences. Not an init* module - there is no element
// to look up, it is a helper the passkey modules share.

export const PASSKEY_UNTERSTUETZT =
  typeof window !== 'undefined' &&
  typeof window.PublicKeyCredential !== 'undefined' &&
  Boolean(window.isSecureContext);

// NotAllowedError is both "the user clicked cancel" and "the dialog timed out",
// with nothing to tell them apart - so the message has to cover both without
// claiming either. InvalidStateError during a registration means excludeCredentials
// matched: this authenticator already has a credential for this account.
function meldungFuer(error, ceremony) {
  if (!error) return 'Der Vorgang ist fehlgeschlagen.';

  switch (error.name) {
    case 'NotAllowedError':
      return 'Der Vorgang wurde abgebrochen oder ist abgelaufen. Bitte versuchen Sie es erneut.';
    case 'InvalidStateError':
      return ceremony === 'registrierung'
        ? 'Dieses Gerät ist für Ihr Konto bereits registriert.'
        : 'Dieser Passkey kann nicht verwendet werden.';
    case 'NotSupportedError':
      return 'Ihr Gerät unterstützt keine Passkeys.';
    case 'SecurityError':
      return 'Passkeys benötigen eine sichere Verbindung (HTTPS).';
    case 'AbortError':
      return 'Der Vorgang wurde abgebrochen.';
    default:
      return 'Der Passkey konnte nicht verwendet werden. Bitte versuchen Sie es erneut.';
  }
}

// Both helpers reject with a plain Error carrying a German message, so a caller
// can show error.message without knowing anything about WebAuthn.
export async function passkeyRegistrieren(optionen) {
  try {
    return await startRegistration({ optionsJSON: optionen });
  } catch (error) {
    throw new Error(meldungFuer(error, 'registrierung'));
  }
}

export async function passkeyAnmelden(optionen) {
  try {
    return await startAuthentication({ optionsJSON: optionen });
  } catch (error) {
    throw new Error(meldungFuer(error, 'anmeldung'));
  }
}
